import gql from 'graphql-tag';

export const QUERY_GET_PROPERTY_TYPES = gql`
  query LP_ListPropertyTypes {
    listPropertyTypes {
      propertyTypes {
        id
        slug
        name
        description
      }
    }
  }
`;

export const QUERY_GET_PROPERTIES_BY_CURRENCY = gql`
  query LP_ListPropertiesByCurrency(
    $currency: NonEmptyString
    $name: String
    $landlordIds: [ID]
    $pageNumber: Int = 1
    $pageSize: Int = 10
    $bookingJourneys: [BookingJourney!]
  ) {
    properties(
      currency: $currency
      name: $name
      landlordIds: $landlordIds
      bookingJourneys: $bookingJourneys
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      totalCount
      edges {
        node {
          id
          name
          slug
          state
          paymentPlanId
          bookingJourney
          status
          apCategory
        }
      }
    }
  }
`;
